"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const tracking_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/tracking-handler");
const browser_1 = require("../../utils/browser");
class SkuSelectorComponent extends Marko.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            selectedVariation: undefined,
            itemCardProps: {
                title: '',
                price: '',
            },
            combinationSelector: undefined,
        };
    }
    onCreate(input) {
        return __awaiter(this, void 0, void 0, function* () {
            this.state = {
                open: false,
                selectedVariation: undefined,
                itemCardProps: {
                    title: '',
                    price: '',
                },
                combinationSelector: undefined,
            };
            this.watchDataProvider = (0, get_1.default)(input, 'watchDataProvider', {});
            const itemDetails = (0, get_1.default)(input, 'itemDetails', {});
            yield this.getItemVariation(itemDetails);
            const trackingInfo = (0, get_1.default)(input, 'trackingInfo', {});
            const pageId = (0, get_1.default)(trackingInfo, 'pageId', '');
            const itemData = (0, get_1.default)(itemDetails, 'itemData', {});
            const trackingData = {
                eventFamily: 'MYEBAY',
                eventAction: 'CLIENT_PAGE_VIEW',
                flushImmediately: false,
                pageId: `p${pageId}`,
                eventProperty: {
                    imp: 4598045,
                },
            };
            (0, tracking_handler_1.handleTracking)(trackingData, itemData);
        });
    }
    handleSelection(selectedVariation) {
        if (!selectedVariation) {
            return;
        }
        const { itemCardProps } = this.state;
        const { price } = selectedVariation;
        this.setState({
            itemCardProps: Object.assign(Object.assign({}, itemCardProps), { price: (price === null || price === void 0 ? void 0 : price.displayValue) || '' }),
            selectedVariation: selectedVariation,
        });
    }
    handleTraitSelection(trait) {
        const { images, value } = trait;
        const { itemCardProps, selectedVariation } = this.state;
        const imageURL = (images && images[0]) || itemCardProps.imageURL;
        this.setState({
            itemCardProps: Object.assign(Object.assign({}, itemCardProps), { imageURL }),
            selectedVariation: !value ? undefined : selectedVariation,
        });
    }
    handleOpen(event) {
        this.emit('open', event);
    }
    handleClose(event) {
        this.emit('close', event);
    }
    handleDone(event) {
        const itemDetails = (0, get_1.default)(this.input, 'itemDetails', {});
        const itemData = (0, get_1.default)(itemDetails, 'itemData', {});
        const trackingInfo = {
            eventFamily: 'MYEBAY',
            eventAction: 'ACTN',
            actionKind: 'CLICK',
            flushImmediately: false,
            pageId: 'p4598045',
            moduleId: 'm170678',
            linkId: 'l187459',
            eventProperty: {
                type: 'watch',
            },
        };
        (0, tracking_handler_1.handleTracking)(trackingInfo, itemData);
        this.emit('done', event, this.state.selectedVariation);
    }
    getItemVariation(itemDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { itemData: { itemId }, } = itemDetails;
            try {
                if ((_a = this.watchDataProvider) === null || _a === void 0 ? void 0 : _a.getItemSkuDetailsHandler) {
                    const response = yield this.watchDataProvider.getItemSkuDetailsHandler(itemId);
                    if ('status' in response) {
                        this.updateSkuItemDetailState(response);
                    }
                }
            }
            catch (error) {
                this.setState({
                    open: false,
                });
                console.error('Error getting SKU item details', error);
                this.showErrorToast('Something went wrong. Please try again.');
            }
        });
    }
    updateSkuItemDetailState(response) {
        if ('status' in response &&
            response.status === 'ERROR' &&
            response.message &&
            response.message.length > 0) {
            const errorMessage = (0, get_1.default)(response, 'message', '');
            return this.showErrorToast(errorMessage);
        }
        try {
            const itemDetails = (0, get_1.default)(response, 'itemDetails', {});
            const combinationSelector = (0, get_1.default)(itemDetails, 'combinationSelector', {});
            const itemCardProps = {
                title: (0, get_1.default)(itemDetails, 'title', ''),
                imageURL: (0, get_1.default)(itemDetails, 'imageURL', ''),
                price: (0, get_1.default)(itemDetails, 'price', ''),
            };
            const { traits, variations } = (0, browser_1.formatTraitsAndVariations)(combinationSelector);
            this.setState({
                itemCardProps,
                combinationSelector: {
                    traits,
                    variations,
                },
            });
        }
        catch (error) {
            console.error('Error formatting SKU item details', error);
            this.showErrorToast('Something went wrong. Please try again.');
        }
    }
    showErrorToast(message) {
        this.setState({
            open: false,
        });
        this.emit('toast', true, message, true);
    }
}
exports.default = SkuSelectorComponent;
